import type * as React from 'react';

function PremiumProductItemV2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="33" viewBox="0 0 174 33" width="174" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#filter0_dd_581_97741)">
        <path d="M10 6.5L10 24.5L3 24.5L5.1 15.5L3 6.5L10 6.5Z" fill="#FBDA2E" />
      </g>
      <g filter="url(#filter1_dd_581_97741)">
        <path d="M164 25L164 9L171 9L168.9 17L171 25L164 25Z" fill="#FBDA2E" />
      </g>
      <g filter="url(#filter2_dd_581_97741)">
        <rect fill="#FBDA2E" height="27" rx="4" width="156" x="9" y="2" />
      </g>
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="24"
          id="filter0_dd_581_97741"
          width="13"
          x="0"
          y="4.5"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.15 0" />
          <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_581_97741" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology in="SourceAlpha" operator="dilate" radius="1" result="effect2_dropShadow_581_97741" />
          <feOffset />
          <feColorMatrix type="matrix" values="0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.05 0" />
          <feBlend in2="effect1_dropShadow_581_97741" mode="normal" result="effect2_dropShadow_581_97741" />
          <feBlend in="SourceGraphic" in2="effect2_dropShadow_581_97741" mode="normal" result="shape" />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="22"
          id="filter1_dd_581_97741"
          width="13"
          x="161"
          y="7"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.15 0" />
          <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_581_97741" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology in="SourceAlpha" operator="dilate" radius="1" result="effect2_dropShadow_581_97741" />
          <feOffset />
          <feColorMatrix type="matrix" values="0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.05 0" />
          <feBlend in2="effect1_dropShadow_581_97741" mode="normal" result="effect2_dropShadow_581_97741" />
          <feBlend in="SourceGraphic" in2="effect2_dropShadow_581_97741" mode="normal" result="shape" />
        </filter>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="33"
          id="filter2_dd_581_97741"
          width="162"
          x="6"
          y="0"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.15 0" />
          <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_581_97741" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology in="SourceAlpha" operator="dilate" radius="1" result="effect2_dropShadow_581_97741" />
          <feOffset />
          <feColorMatrix type="matrix" values="0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.05 0" />
          <feBlend in2="effect1_dropShadow_581_97741" mode="normal" result="effect2_dropShadow_581_97741" />
          <feBlend in="SourceGraphic" in2="effect2_dropShadow_581_97741" mode="normal" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export default PremiumProductItemV2;
